import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider Agenda
    const eventsSlideshow = document.querySelector('.events .swiper-container') !== null;
    if (eventsSlideshow) {
        let eventsSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;
        Swiper.use([ Navigation, A11y ]);

        let eventsConfig = {
            grabCursor : 'true',
            speed: 700,
            // loop : true,
            slidesPerView: 'auto',
            spaceBetween: 10,

            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                641: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                961: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },

                1201: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },

            navigation: {
                prevEl: `.js-events-swiper-nav--prev`,
                nextEl: `.js-events-swiper-nav--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(window.innerWidth > 960) {
            if(eventsSlides > 3) {
                let swiperEvents = new Swiper('.events .swiper-container', eventsConfig);
            }
        } else if(window.innerWidth > 640) {
            if(eventsSlides > 2) {
                let swiperEvents = new Swiper('.events .swiper-container', eventsConfig);
            }
        } else {
            if(eventsSlides > 1) {
                let swiperEvents = new Swiper('.events .swiper-container', eventsConfig);
            }    
        }
    }

    // Slider News

    const newsSlideshow = document.querySelector('.news .swiper-container') !== null;

    if (newsSlideshow) {
        let newsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;

        Swiper.use([ Navigation, A11y ]);

        let newsConfig = {
            grabCursor : 'true',
            speed: 700,
            // loop : true,
            slidesPerView: 'auto',
            spaceBetween: 10,

            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                641: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                961: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                1201: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
            },

            navigation: {
                prevEl: `.js-news-swiper-nav--prev`,
                nextEl: `.js-news-swiper-nav--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(window.innerWidth > 960) {
            if(newsSlides >= 3) {
                let swiperNews = new Swiper('.news .swiper-container', newsConfig);
            }
        } else if(window.innerWidth > 640) {
            if(newsSlides > 2) {
                let swiperNews = new Swiper('.news .swiper-container', newsConfig);
            }
        } else {
            if(newsSlides > 1) {
                let swiperNews = new Swiper('.news .swiper-container', newsConfig);
            }    
        }
    }

}
